// extracted by mini-css-extract-plugin
module.exports = {"center":"styles_center__5Taec","light":"styles_light__jiIgC"};